import { formatToCurrency } from '@utils/formats';
import type { FC } from 'react';

type OrderDetailsProductProps = {
  id: string;
  cantidad: number;
  nombre: string;
  presentacion: string;
  subtotal: number;
  instrucciones: string;
  extras: { id: string; cantidad: number; nombre: string; precio?: number }[];
};

const OrderDetailsProduct: FC<OrderDetailsProductProps> = ({
  cantidad,
  extras,
  id,
  nombre,
  presentacion,
  subtotal,
  instrucciones,
}) => {
  return (
    <div className="flex py-2 border-b mb-1" key={id}>
      <div className="w-full flex flex-col">
        <div className="flex justify-between font-bold pl-1">
          <div className="flex-col">
            <p>
              {' '}
              {cantidad} x {nombre}{' '}
            </p>
            {/* Los productos de precio único guardan `presentacion: ''`. Sin este guard el
                párrafo se pinta vacío y deja un renglón muerto bajo el nombre del producto. */}
            {presentacion?.trim() && <p className="font-medium">{presentacion}</p>}
          </div>
          <div className="">
            <span>{formatToCurrency(Number(subtotal))}</span>
          </div>
        </div>
        {extras.map((ext) => (
          <div key={ext.id} className="flex justify-between text-sm mr-2">
            <p className="pl-4">
              {ext.cantidad} x {ext.nombre}
            </p>
            {ext.precio ? `$ ${ext.precio}` : ''}
          </div>
        ))}
        {instrucciones && (
          <p>
            <span className="text-color-secondary">Instrucciones:</span> {instrucciones}
          </p>
        )}
      </div>
    </div>
  );
};
export default OrderDetailsProduct;
